import { defineStore } from 'pinia'

import { useEventStore } from './event'
import { usePreweddingStore } from './prewedding'
import { useSettingControlStore } from './settingControl'
import { useTemplateStore } from './template'
import { useWishStore } from './wish'

import { useWindowSize } from '@vueuse/core'

import delay from '~/utils/delay'

import _forEach from 'lodash/filter.js'
import _first from 'lodash/first.js'
import _size from 'lodash/size.js'
import _map from 'lodash/map.js'
import _includes from 'lodash/includes.js'
import _concat from 'lodash/concat.js'
import _shuffle from 'lodash/shuffle.js'
import _filter from 'lodash/filter.js'
import _has from 'lodash/has.js'
import _take from 'lodash/take.js'
import _cloneDeep from 'lodash/cloneDeep.js'

export const useSlideStore = defineStore({
  id: 'slide',
  state: () => {
    return {
      tmpMode: '',
      //
      stage: null as any,
      isRender: true,
      view: 'prewedding', // prewedding, wish
      playMode: '', // mix, wish
      index: -1,  // init start with -1
      limit: 4,  // limit play instace per set
      second: 0,
      percent: 0,
      loopCount : -1,
      wishInstance: {} as any,
      showNewWishIcon: false,
      preweddingInstance: null as any,

      //iconDisplay: 'prewedding', // prewedding, wish, new_wish  

      previousView: {
        view: null,
        index: null,
        active: false
      }, // prewedding, wish

      allInstancesPlayed: 0,
      preweddingInstancesPlayed: 0,
      wishInstancesPlayed: 0,

      settimeOutInstance: null,
      setIntervalPercent: null,

      timerMs: 0,
      INTERVAL: 1000,

      watchIndexId: null,
      transitionWish: true,
      transitionOpacity: 1,

      myWorker: undefined,

      // -------- new ---------
      listHolder: [] as any,
      localPlayed: {} as any,

      // ------ example -----
      isExampleMode: false,

      // ไม่เหลืออะไรให้เล่นแล้ว (เช่น คำอวยพรถูกลบหมดในโหมด wish)
      isQueueEmpty: false,
    }
  },
  actions: {

    initWebWorkerMessage() {
      const self = this;
      self.isQueueEmpty = false

      if (!self.myWorker || self.myWorker === 'undefined') {
        self.myWorker = new Worker('/js/worker.js');
      }

      // Receive messages from the worker
      self.myWorker.onmessage = function (e) {
        const message = e.data
        console.log(message);
        self.main()
      }
    },

    main() {
      const wishStore = useWishStore()
      this.index++

      // ---- new ------
      let newWishList = wishStore.getNewDocIdList() // จะนับก็ต่อเมื่อกำลังเล่นอยู่แล้วมีใหม่เข้ามา

      // เริ่มเล่นครั้งแรกหรือเมื่อเล่นจะหมดแล้ว
      if (this.listHolder?.length === 0) {
        this.checkAndClearPlayed() // clear played obj เมื่อเล่นครบหมดแล้ว
        this.generateQueueAndRandom() // เอารูป prewedding กับ wish มากองรวมกัน -> this.listHolder
        this.index = 0
      }

      // สร้างคิวใหม่แล้วยังว่าง = ไม่มีอะไรให้เล่นแล้ว -> หยุด ไม่งั้นจะวนเรียกตัวเองจน stack ล้น
      // แจ้งเตือนเฉพาะโหมด wish เท่านั้น
      if (this.listHolder?.length === 0 && newWishList.length === 0) {
        this.stop({ notify: this.playMode === 'wish' })
        return
      }

      let currentView = this.getCurrentView(newWishList)
      let currentDisplay = currentView === 'new_wish' ? newWishList[0] : this.listHolder[0];
      //-----------------------


      switch (currentView) {
        case 'prewedding':
          this.view = 'prewedding'
          this.showNewWishIcon = false
          this.renderPrewedding();
          this.updateLocalPlay(currentDisplay)
          this.listHolder.shift() // คือตัวเดียวกันกับ preweddingStore.queue[0]
          break;
        case 'wish':
          this.view = 'wish'
          this.showNewWishIcon = false
          this.renderWish();
          this.updateLocalPlay(currentDisplay)
          this.listHolder.shift() // คือตัวเดียวกันกับ wishStore.queue[0]
          break;
        case 'new_wish':
          this.view = 'wish'
          this.showNewWishIcon = true
          const newWishId = newWishList[0]
          this.renderWish(newWishId);
          this.updateLocalPlay(newWishId) // new
          wishStore.newWishes.shift();
          break;
        default:
          break;
      }

      this.startTimer()

      // worker clear timer and run
      if (window.Worker) {
        this.myWorker && this.myWorker.postMessage({
          company: 'photowish',
          timer: this.itemTimer * 1000,
        });

      } else {
        this.settimeOutInstance = setTimeout(() => {
          this.main()
        }, (this.itemTimer * 1000) + 20)
      }

      this.allInstancesPlayed++
      
    },

    async renderWish(forceDocId = null) {
      const wishStore = useWishStore()
      const templateStore = useTemplateStore()

      let docId = forceDocId || this.listHolder[0]
      let current = wishStore.getWishDataById(docId)
      // not found wish maybe user delete wish
      if (!current) {
        this.listHolder.shift()
        this.clearTimer()

        // โหมด wish อย่างเดียว: ลบคำอวยพรหมดแล้ว ไม่เหลือให้เล่นต่อ -> หยุดและแจ้งเตือน
        // โหมด mix ไม่ต้องหยุด เพราะ generateQueueAndRandom() จะเติมรูป prewedding ให้เล่นต่อได้
        if (
          this.playMode === 'wish' &&
          this.listHolder.length === 0 &&
          wishStore.getNewDocIdList().length === 0
        ) {
          this.stop({ notify: true })
          return
        }

        // setTimeout เพื่อตัด call stack กันเรียกซ้อนกันเมื่อเจอ docId ที่ถูกลบติดกันหลายตัว
        setTimeout(() => this.next(), 0)
        return
      }
      console.log("wishInstancesPlayed", this.wishInstancesPlayed, current)
      this.wishInstance = current

      if (this.stage && this.stage.destroy) {
        this.stage.width(0)
        this.stage.height(0)
        console.log("destroy stage", this.wishInstancesPlayed)
        this.stage.batchDraw()
        this.stage.destroy()
        this.stage = null
        this.transitionWish = false
        this.transitionOpacity = 0
      }

      try {
        templateStore.docId = docId
        const renderStage = await templateStore.render(current)
        templateStore.docId = docId

        // -- transition  animation --
        this.transitionWish = true
        this.transitionOpacity = 1
        // ---------------------------

        this.stage = renderStage
        this.wishInstancesPlayed++

        wishStore.updatePlayWish(current) // <== database

      } catch (error) {
        console.error(error)
      }

    },
    async renderPrewedding() {
      this.stage && this.stage.destroy()
      this.stage = null

      const tmpStage = this.stage
      if (tmpStage) {
        tmpStage.destroy()
        this.stage = null
      }
      this.preweddingInstance = this.listHolder[0]
      this.preweddingInstancesPlayed++
    },

    //---
    async startTimer() {

      this.clearTimer()
      const durationSec = this.itemTimer

      //percent  

      this.setIntervalPercent = setInterval(() => {

        this.timerMs = this.timerMs + this.INTERVAL

        this.percent = (this.timerMs / (durationSec * 1000)) * 100
        if (this.percent >= 100) {
          this.percent = 100
        }
      }, this.INTERVAL)


    },
    clearTimer() {
      this.setIntervalPercent = clearInterval(this.setIntervalPercent)

      this.percent = 0
      this.timerMs = 0
    },

    // หยุดสไลด์ทั้งหมด; notify = true จะยกธงให้หน้าเพจไปแจ้งเตือนผู้ใช้
    stop({ notify = false } = {}) {
      this.clearTimer()
      this.settimeOutInstance = clearTimeout(this.settimeOutInstance)

      // ต้องเคลียร์ myWorker ด้วย ไม่งั้น initWebWorkerMessage() จะไม่สร้าง worker ใหม่ตอนเล่นรอบหน้า
      if (this.myWorker) {
        this.myWorker.terminate()
        this.myWorker = undefined
      }

      if (notify) {
        this.isQueueEmpty = true
      }
    },

    rerender() {
      this.isRender = false
      setTimeout(() => {
        this.isRender = true
      }, 800)
    },

    next() {
      this.main()
    },

    checkAndClearPlayed() {
      this.localPlayed = {}
    },

    generateQueueAndRandom() {

      const wishStore = useWishStore()
      const preweddingStore = usePreweddingStore()

      let wish_onlyIds = _map(wishStore.allWishDatabase, w => w.docId)
      let prewedding = preweddingStore.all

      // กองรวมกัน & shuffle &  save local 
      let temp_allList = []

      // mode : wish only
      if (this.playMode == 'wish') {
        temp_allList = _concat(wish_onlyIds)
      } else {
        temp_allList = _concat(wish_onlyIds, prewedding)
      }
      temp_allList = _shuffle(temp_allList)

      this.listHolder = temp_allList
      this.loopCount++
    },
    filterPreweddingOut() {
       
      this.listHolder = _filter(this.listHolder, (l) => !l.startsWith('https://'))
    },
    updateLocalPlay(data: any) {
      // wish
      if (data) {
        this.localPlayed[data] = true
      }

      // prewedding
      if (_includes(data, 'https://')) {
        this.localPlayed[data] = true
      }
    },

    getCurrentView(newWishList: any) {
      if (newWishList.length > 0) {
        return 'new_wish'
      }

      if (_includes(this.listHolder[0], 'https://')) {
        return 'prewedding'
      }else{
        return 'wish'
      }
    }

  },
  getters: {
    itemLimit(state) {
      const settingControl = useSettingControlStore()
      const timer: any = settingControl.timer
      let view = state.view

      return timer[view].limit
    },
    itemTimer(state) {
      const settingControl = useSettingControlStore()

      const timer: any = settingControl.timer
      // console.log(timer)
      const view = state.view
      return timer[view].timer
    },

  }
})
